export default function formatPrice(
  cents: number,
  { round, include }: { round?: boolean; include?: boolean } = {}
) {
  if (include && cents === 0) return "Included";
  const price = cents / 100;
  const shouldRound = round && cents % 100 === 0;
  const str = price.toLocaleString(undefined, {
    minimumFractionDigits: shouldRound ? 0 : 2,
    maximumFractionDigits: 2,
  });
  return `$${str}`;
}
